export default __webpack_public_path__ + "static/B05-d7416828a1e9c21618501689561d188a.png";